import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = {
  key: 2,
  class: "text-xs text-gray-400"
}
const _hoisted_3 = { class: "flex items-center gap-x-2" }
const _hoisted_4 = { class: "flex gap-x-1" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Okay")

import { ref } from 'vue';
import Modal from '@/components/Modal/Modal.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  title: {
    type: String,
    default: null,
  },
  hint: {
    type: String,
    default: null,
  },
  validationError: {
    type: String,
    default: null,
  },
},
  emits: ['status-clicked'],
  setup(__props, { emit }) {





const visibleBadge = ref(false);

function statusClicked() {
  emit('status-clicked');
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _mergeProps({
      class: ['input-field w-full text-sm', { error: __props.validationError }]
    }, _ctx.$attrs), [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          (__props.title && !_ctx.$slots['title'])
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([
            'font-bold flex items-center',
            { 'text-red-500': __props.validationError },
          ])
              }, [
                _renderSlot(_ctx.$slots, "title-badge"),
                _createTextVNode(_toDisplayString(__props.title), 1)
              ], 2))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass([
            'font-bold flex items-center',
            { 'text-red-500': __props.validationError },
          ])
              }, [
                _renderSlot(_ctx.$slots, "title")
              ], 2)),
          (__props.hint)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.hint), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "badge"),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.$slots['notes'])
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", {
                    class: "flex items-center justify-center w-6 h-6 text-white rounded cursor-pointer bg-primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (visibleBadge.value = true))
                  }, " ? ")
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: "status",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (statusClicked()))
          }, [
            _renderSlot(_ctx.$slots, "status")
          ])
        ])
      ]),
      _renderSlot(_ctx.$slots, "default"),
      (__props.validationError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(__props.validationError), 1))
        : _createCommentVNode("", true)
    ], 16),
    (_ctx.$slots['notes'] && visibleBadge.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 0,
          header: "Notes",
          onClose: _cache[3] || (_cache[3] = ($event: any) => (visibleBadge.value = false))
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_Button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (visibleBadge.value = false))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "notes")
          ]),
          _: 3
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})